import axios from "axios";
import qs from "qs";
export default class BaseApiClient {
    _baseUrl;
    http;
    constructor(baseURL) {
        this._baseUrl = baseURL || "";
        this.http = axios.create({
            withCredentials: true
        });
        this.http.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    }
    paramsSerializer = (params = {}) => qs.stringify(params, { arrayFormat: "comma" });
    /**
     * Provides type-safe GET call.
     *
     * @param path
     * @param options
     * @returns
     */
    get(path, options = {}) {
        return this.http
            .request({
            url: this._baseUrl + path,
            paramsSerializer: this.paramsSerializer,
            ...options
        })
            .then((response) => {
            return response.data;
        });
    }
    /**
     * Provides type-safe POST call.
     *
     * @param path
     * @param options
     * @returns
     */
    post(path, options = {}) {
        return this.http
            .request({
            url: this._baseUrl + path,
            method: "POST",
            headers: {
                CSRFToken: window.Ramius.token
            },
            ...options
        })
            .then((response) => {
            return response.data;
        })
            .catch((error) => {
            throw this.wrapError(error);
        });
    }
    /**
     * Provides type-safe PUT call.
     *
     * @param path
     * @param options
     * @returns
     */
    put(path, options = {}) {
        return this.http
            .request({
            url: this._baseUrl + path,
            method: "PUT",
            headers: {
                CSRFToken: window.Ramius.token
            },
            ...options
        })
            .then((response) => {
            return response.data;
        })
            .catch((error) => {
            throw this.wrapError(error);
        });
    }
    /**
     * Provides type-safe PATCH call.
     *
     * @param path
     * @param options
     * @returns
     */
    patch(path, options = {}) {
        return this.http
            .request({
            url: this._baseUrl + path,
            method: "PATCH",
            headers: {
                CSRFToken: window.Ramius.token
            },
            ...options
        })
            .then((response) => {
            return response.data;
        })
            .catch((error) => {
            throw this.wrapError(error);
        });
    }
    /**
     * Provides type-safe DELETE call.
     *
     * @param path
     * @param options
     * @returns
     */
    delete(path, options = {}) {
        return this.http
            .request({
            url: this._baseUrl + path,
            method: "DELETE",
            headers: {
                CSRFToken: window.Ramius.token
            },
            ...options
        })
            .then((response) => {
            return response.data;
        })
            .catch((error) => {
            throw this.wrapError(error);
        });
    }
    wrapError = ({ message, request, response }) => {
        const wrappedError = { message, statusCode: 400 };
        // `response` & `request` are only available on Axios errors. Update `wrappedError` accordingly.
        if (response) {
            const { status: statusCode, statusText, data } = response;
            const { error, type, details } = data;
            Object.assign(wrappedError, {
                statusCode,
                message: statusText || String({ error, type }),
                error,
                type,
                details
            });
        }
        else if (request) {
            wrappedError.statusCode = 404;
        }
        return wrappedError;
    };
}
